import { SendIntegrationPrivateKeyType } from '../enums/send-integration-private-key-type.enum'

export interface IApnsConfiguration {
    is_active: boolean
    expiration?: string | null
    push_package: {
        website_push_id: string
        icon_source_url: string
    }
    private_key: {
        private_key_file_url: string
        private_key_password?: string
    }
}

export enum SendIntegrationChannel {
    WEB = 'WEB',
    NATIVE = 'NATIVE',
}

export enum FcmSendIntegrationApiVersion {
    LEGACY = 'LEGACY',
    V1 = 'V1',
}

export interface IAbstractSendIntegration {
    isActive: boolean
}

// Possible Combinations

// WEB APNS - existing domains.apns_configuration_json JSONB
export interface IWebApnsSendIntegration extends IAbstractSendIntegration {
    readonly expiration?: string // ISO8601 Date String
    privateKey: {
        privateKeyFileUrl: string
        privateKeyPassword: string | null
    }
    pushPackage: {
        websitePushId: string
        iconSourceUrl: string
    }
}

type RequireKeys<T, Key extends keyof T> = T & { [K in Key]-?: T[K] }

// NATIVE APNS - domains.native_apns_configuration JSONB
export interface IAbstractNativeApnsSendIntegration extends IAbstractSendIntegration {
    appBundleId?: string
    privateKeyFileUrl?: string
    privateKeyType?: SendIntegrationPrivateKeyType
    // P12 Only
    privateKeyPassPhrase?: string
    expiration?: string
    // P8 Only
    teamId?: string
    keyId?: string
}

// NATIVE FCM - domains.native_fcm_configuration JSONB
export interface IAbstractNativeFcmSendIntegration extends IAbstractSendIntegration {
    apiVersion?: FcmSendIntegrationApiVersion
    senderId?: string
    // LEGACY Only
    serverApiKey?: string
    // V1 Only
    serviceAccountJsonFileUrl?: string
}

export type NativeLegacyFcmSendIntegration = {
    is_active: true
    api_version: FcmSendIntegrationApiVersion.LEGACY
} & RequireKeys<Omit<IAbstractNativeFcmSendIntegration, 'serviceAccountJsonFileUrl'>, 'serverApiKey'>

export type NativeV1FcmSendIntegration = {
    is_active: true
    api_version: FcmSendIntegrationApiVersion.V1
} & RequireKeys<Omit<IAbstractNativeFcmSendIntegration, 'serverApiKey'>, 'serviceAccountJsonFileUrl'>

export interface IPushPackageConfiguration {
    website_push_id?: string
    icon_source_url?: string
}

export interface IAbstractApnsPrivateKeyConfiguration {
    private_key_file_url: string
    private_key_pass_phrase?: string
}
